// src/config/securityLinks.js
// Central place for public security-related links used in the UI.
// Note: these are NOT secrets. Keeping them here is for maintainability.

export const SECURITY_LINKS = {
  GOOGLE_ACCOUNT_SECURITY: "https://myaccount.google.com/security",
};

export const AUTH0_PATHS = {
  CHANGE_PASSWORD: "/dbconnections/change_password",
};
